<sim-snackbar icon="fa-info-circle" [duration]="data.duration">
	<ng-container label>
		{{ infoMessage() | translate }}
	</ng-container>
</sim-snackbar>
